import { getColor } from '@chakra-ui/theme-tools'

type Props = Record<string, any>

export default {
  sizes: {
    sm: (props: Props) => ({
      control: {
        _checked: {
          border: `1px ${getColor(props.theme, 'blue.500')} solid`,
        },
      },
      label: {
        _invalid: {
          color: 'red.500',
        },
      },
    }),
    md: (props: Props) => ({
      control: {
        _checked: {
          border: `1px ${getColor(props.theme, 'blue.500')} solid`,
        },
      },
      label: {
        _invalid: {
          color: 'red.500',
        },
      },
    }),
    lg: (props: Props) => ({
      control: {
        _checked: {
          border: `2px ${getColor(props.theme, 'blue.500')} solid`,
        },
      },
      label: {
        _invalid: {
          color: 'red.500',
        },
      },
    }),
  },
}
